import { useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import chest from '~/assets/icons/chest.svg';
import { ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { CloseButton } from '~/components/ui/CloseButton';
import { ShopBalance } from '~/components/ui/ShopBalance';
import { Text } from '~/components/ui/Text';
import { rage, useInputAction, useObservable } from '~/rage';
import { InputAction, TechTuningCaseType } from '~/shared';
import {
	setCasesOverlayVisible,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { CaseItem } from '../CaseItem';
import { CaseItemList } from '../CaseItemList';
import {
	StyledCasesContainer,
	StyledContainer,
	StyledHead,
	StyledHeadLeft,
	StyledHeadRight,
	StyledListContainer,
	StyledShadow,
	StyledWrapper,
} from './CasesOverlay.styled';

const CasesOverlay = () => {
	const dispatch = useLayoutDispatch();
	const [selectedCase, setSelectedCase] = useState<TechTuningCaseType | null>(
		null,
	);
	const [lastSelectedCase, setLastSelectedCase] = useState<TechTuningCaseType>(
		TechTuningCaseType.STANDART,
	);
	const modalState = useObservable(rage.modal.getCurrentModal());
	const caseResultVisible = useLayoutSelector(
		(state) => state.tuningShop.caseResultVisible,
	);

	useInputAction(InputAction.CommonMenuClose, () => {
		if (modalState || caseResultVisible) {
			return;
		}

		if (selectedCase) {
			setSelectedCase(null);
			return;
		}

		dispatch(setCasesOverlayVisible(false));
	});

	return (
		<StyledWrapper>
			<StyledShadow />
			<StyledContainer>
				<StyledHead>
					<StyledHeadLeft>
						<img src={chest} />
						<Text>Тюнинг кейсы</Text>
					</StyledHeadLeft>
					<StyledHeadRight>
						<ShopBalance transparent />
						<CloseButton
							height={ButtonHeight.Height40}
							color={ButtonColors.Default}
							iconSize={14}
							onClick={() => dispatch(setCasesOverlayVisible(false))}
						/>
					</StyledHeadRight>
				</StyledHead>
				<StyledCasesContainer
					style={{ gap: selectedCase ? 0 : 20 }}
					$delay={selectedCase ? 0.5 : 0.3}
				>
					<CaseItem
						type={TechTuningCaseType.STANDART}
						handleSelect={() => {
							setSelectedCase(TechTuningCaseType.STANDART);
							setLastSelectedCase(TechTuningCaseType.STANDART);
						}}
						hidden={
							!!selectedCase && selectedCase !== TechTuningCaseType.STANDART
						}
						selected={selectedCase === TechTuningCaseType.STANDART}
						handleBack={() => setSelectedCase(null)}
					/>
					<CaseItem
						type={TechTuningCaseType.DIAMOND}
						handleSelect={() => {
							setSelectedCase(TechTuningCaseType.DIAMOND);
							setLastSelectedCase(TechTuningCaseType.DIAMOND);
						}}
						hidden={
							!!selectedCase && selectedCase !== TechTuningCaseType.DIAMOND
						}
						selected={selectedCase === TechTuningCaseType.DIAMOND}
						handleBack={() => setSelectedCase(null)}
					/>
					<CaseItem
						type={TechTuningCaseType.MAXIMUM}
						handleSelect={() => {
							setSelectedCase(TechTuningCaseType.MAXIMUM);
							setLastSelectedCase(TechTuningCaseType.MAXIMUM);
						}}
						hidden={
							!!selectedCase && selectedCase !== TechTuningCaseType.MAXIMUM
						}
						selected={selectedCase === TechTuningCaseType.MAXIMUM}
						handleBack={() => setSelectedCase(null)}
					/>
				</StyledCasesContainer>
				<CSSTransition
					in={!!selectedCase}
					timeout={300}
					classNames="list"
					unmountOnExit
				>
					<StyledListContainer $isEntering={!!selectedCase}>
						<CaseItemList type={selectedCase || lastSelectedCase} />
					</StyledListContainer>
				</CSSTransition>
			</StyledContainer>
		</StyledWrapper>
	);
};

export { CasesOverlay };
